import { TableBody as MUITableBody, TableCell, TableProps, TableRow } from '@mui/material';
import { ColorPalette } from 'shared/consts/colorPalette';
import { prepareCell } from 'shared/ui/tables/_common/helpers/prepareCell';
import { Column } from 'shared/ui/tables/_common/types';

interface Props<T> extends TableProps {
	columns: Array<Column<T>>;
	rows: Array<T & { id: string }>;
}
export function TableBody<T>({ columns, rows }: Props<T>) {
	return (
		<MUITableBody
			sx={{
				'& > * + *': {
					borderTop: `1.5px solid ${ColorPalette.zircon}`,
				},
			}}
		>
			{rows.map((row) => (
				<TableRow
					sx={{
						'position': 'relative',
						'margin': '0',
						'&:hover': { backgroundColor: ColorPalette.zircon },
						'cursor': 'pointer',
					}}
					key={row.id}
					onClick={(e) => {
						const target = e.target as HTMLElement;

						if (
							!target.classList.contains('MuiBox-root') &&
							target.getAttribute('class') !== 'icon' &&
							target.getAttribute('class') !== '' &&
							!target.classList.contains('MuiBackdrop-root') &&
							target.classList.value !== '' &&
							!target.classList.contains('MuiBackdrop-invisible') &&
							!target.classList.contains('MuiModal-backdrop') &&
							// !target.classList.contains('MuiTypography-root') &&
							!target.classList.contains('MuiTypography-caption') &&
							!target.classList.contains('css-repb39-MuiTypography-root') &&
							!target.classList.contains('MuiButtonBase-root') &&
							!target.classList.contains('MuiMenuItem-root') &&
							!target.classList.contains('MuiMenuItem-gutters') &&
							!target.classList.contains('css-13jn1as-MuiButtonBase-root-MuiMenuItem-root')
						) {
							// eslint-disable-next-line @typescript-eslint/ban-ts-comment
							// @ts-ignore
							row?.user?.navigateToDetails(row.user);
						}
					}}
				>
					{columns.map((column) => {
						// eslint-disable-next-line @typescript-eslint/ban-ts-comment
						// @ts-ignore

						let prepareFieldFn, renderCellFn, restBodyCellSettings;
						if (column?.bodyCellSettings) {
							const { prepareField, renderCell, ...rest } = column.bodyCellSettings;
							prepareFieldFn = prepareField;
							renderCellFn = renderCell;
							restBodyCellSettings = rest;
						}

						const preparedCell = prepareCell(row, prepareFieldFn, renderCellFn);

						return preparedCell !== null ? (
							<TableCell
								key={column.field}
								sx={{
									'padding': '0 10px',
									'border': 'none',
									'height': '81px',
									'color': ColorPalette.astronaut,
									'&:first-of-type': {
										paddingLeft: '24px',
									},
									'&:last-of-type': {
										paddingRight: '24px',
									},
								}}
								{...column?.commonCellSettings}
								{...restBodyCellSettings}
							>
								{preparedCell}
							</TableCell>
						) : null;
					})}
				</TableRow>
			))}
		</MUITableBody>
	);
}
